import { CircularProgress, Grid, MenuItem } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { Country } from '../../../../interfaces/Country';
import CustomTextField from '../../../CustomTextInput';

interface SelectorInterface {
    error: boolean;
    id: string;
    value: string | number;
    label: string;
    name: string;
    changeFunction: (e: ChangeEvent<HTMLInputElement>) => void;
    countries: Country[];
    isCountriesLoading: boolean;
    helperText: string | undefined;
    gridWidth?: number;
}

const CountrySelector = ({
    error,
    id,
    value,
    label,
    name,
    changeFunction,
    countries,
    isCountriesLoading,
    helperText,
    gridWidth = 6
}: SelectorInterface) => {
    return (
        <Grid item xs={12} md={12} lg={gridWidth}>
            <CustomTextField
                select
                error={error}
                helperText={helperText}
                required
                id={id}
                label={label}
                name={name}
                value={value}
                onChange={changeFunction}
            >
                {isCountriesLoading ? (
                    <MenuItem>
                        <CircularProgress size={20} />
                    </MenuItem>
                ) : (
                    countries.map((item: Country) => (
                        <MenuItem
                            value={item.id || ''}
                            key={`countries-final-${item.id}`}
                        >
                            <div className='flex items-center'>
                                <img
                                    src={item?.flagImageUrl}
                                    alt={`${item.name}-flag`}
                                    className='w-4 h-4'
                                />
                                <span className='ml-2'>{item.name}</span>
                            </div>
                        </MenuItem>
                    ))
                )}
            </CustomTextField>
        </Grid>
    );
};

export default CountrySelector;
